import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_SERVICE_PLAN_RESOURCE_NAMES,
    CLEAR_SERVICE_PLAN_RESOURCE_NAMES_ERROR,
    LOAD_SERVICE_PLAN_RESOURCE_NAMES_REQUEST,
    LOAD_SERVICE_PLAN_RESOURCE_NAMES_SUCCESS,
    LOAD_SERVICE_PLAN_RESOURCE_NAMES_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_SERVICE_PLAN_RESOURCE_NAMES,
    CLEAR_ERROR: CLEAR_SERVICE_PLAN_RESOURCE_NAMES_ERROR,
    LOAD_REQUEST: LOAD_SERVICE_PLAN_RESOURCE_NAMES_REQUEST,
    LOAD_SUCCESS: LOAD_SERVICE_PLAN_RESOURCE_NAMES_SUCCESS,
    LOAD_FAILURE: LOAD_SERVICE_PLAN_RESOURCE_NAMES_FAILURE
}